import React, { useContext, useState } from 'react';
import { BsCalendarDate } from 'react-icons/bs';
import { MdExitToApp } from "react-icons/md";
import { PiStudent } from "react-icons/pi";
import JoinStudent from './JoinStudent/JoinStudent.jsx';
import DiscountTAble from './discount/DiscountTable.jsx';
import StudentTable from "./studentTable.jsx";
import studentsExit from './studentsExit/studentsExit.jsx';
import Indebnet from './inedebnet/Indebnet.jsx';
import { ThemeContext } from '../context/index.jsx';

const tabs = [
    {
        id: "profile",
        label: "O'quvchilar",
        icon: PiStudent,
        component: StudentTable,
    },
    {
        id: "add",
        label: "Yangi Qo'shilgan O'quvchilar",
        icon: PiStudent,
        component: JoinStudent,
    },
    {
        id: "davomat",
        label: "Chegirmadagi O'quvchilar",
        icon: BsCalendarDate,
        component: DiscountTAble,
    },
    {
        id: "studentexit",
        label: "Chiqib Ketgan O'quvchilar",
        icon: MdExitToApp,
        component: studentsExit,
    },
    {
        id: "studentqarz",
        label: "Qarzi bor O'quvchilar",
        icon: MdExitToApp,
        component: Indebnet,
    },
];

function StudentTab() {
const { profile } = useContext(ThemeContext);
    const [activeTab, setActiveTab] = useState("profile");

    const ActiveContent = tabs.find((tab) => tab.id === activeTab)?.component || null;

    return (
        <div className="w-full  p-0">
            <div className="flex flex-col sm:flex-row border-b border-gray-200">
                {
                tabs.map((tab) => (
                    <button
                        key={tab.id}
                        className={`flex items-center gap-2 py-2 px-4 focus:outline-none ${activeTab === tab.id
                            ? "border-b-2 border-blue-600"
                            : "border-b border-gray-200"
                            }`}
                        onClick={() => setActiveTab(tab.id)}
                    >
                        <tab.icon className="text-xl" /> {tab.label}
                    </button>
                ))}
            </div>
            <div className="p-1 w-full">
                {ActiveContent ? <ActiveContent /> : "Contentni ko'rsatish kerak bo'lgan joyda misol tekstni qo'shing."}
            </div>
        </div>
    );
}

export default StudentTab;

